import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicePathsSettings } from '../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { TemplateUtenteAdapter } from '../../components/profili-utente/template-utente-update/template-utente-adapter';
import { TemplateProfiloResponse } from '../../models/dto/template-profilo-response';
import { TemplatesProfiloResponse } from '../../models/dto/templates-profilo-response';
import { GruppoTerritoriale } from '../../models/gruppo-territoriale';
import { TemplateProfilo } from '../../models/profili-utente/template-profilo';
import { TemplateUtenteProfilo } from '../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../models/profili-utente/utente-profilo';
import { BaseForm } from '../base-Form';
import { PermessoCustom } from './permesso-custom';
import { TemplateRuolo } from '../../models/profili-utente/template-ruolo';
import { TemplatePermessoPerGruppoOrganizzativo } from '../../models/profili-utente/template-permesso-gruppo-organizzativo';

declare var removeEmptyObject: any;
declare var $: any;

export abstract class TemplateUtenteForm extends BaseForm {
  templateUtenteForm: FormGroup;
  request: TemplateUtenteProfilo;
  listaGruppiOperativi: GruppoTerritoriale[];
  listaGruppiOrganizzativi: GruppoTerritoriale[];
  listaGruppiVisibilita: GruppoTerritoriale[];
  listaRuoli: GruppoTerritoriale[];
  listaPermessi: GruppoTerritoriale[];
  permessiCustom: PermessoCustom[];
  listaGruppiSpeciali: GruppoTerritoriale[];
  allGruppiOperativi: boolean;
  allGruppiOrganizzativi: boolean;
  allGruppiVisibilita: boolean;
  allRuoli: boolean;
  allpermessi: boolean;
  utente: UtenteProfilo;
  addMod: boolean;
  listaTemplateUtente: TemplateUtenteProfilo[];
  urlGetTemplates: string;
  urlGetTemplate: string;
  togglesLoaded: boolean;
  gruppiPermessiSelezionati: any[] = [];
  permessiAperti: { [gruppoId: string]: boolean } = {};

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
    this.allGruppiOperativi = false;
    this.allGruppiOrganizzativi = false;
    this.allGruppiVisibilita = false;
    this.allRuoli = false;
    this.allpermessi = false;
    this.addMod = false;
  }

  closeToggles() {
    $('#subgruppo_competenza1false').collapse('hide');
    $('#subgruppo_competenza2false').collapse('hide');
    $('#subgruppo_competenza3false').collapse('hide');
    $('#subgruppo_competenza5false').collapse('hide');
    $('#subgruppo_competenza6false').collapse('hide');
    $('#subgruppo_visibilitaOperativitaGruppofalse').collapse('hide');
  }

  createForm() {
    this.closeToggles();
    this.togglesLoaded = false;
    if (this.utente && !this.addMod) {
      this.createFormUtente();
    } else {
      this.createFormTemplate();
    }
  }

  createFormTemplate() {
    this.request = new TemplateUtenteAdapter(this.getTemplateUtente()).templateUtente;
    this.templateUtenteForm = this.campiForm.group({
      label: [this.request.label, Validators.required]
    });
  }

  createFormUtente() {
    this.request = new TemplateUtenteAdapter(this.getTemplateUtente()).templateUtente;
    this.request.id = '-1';
    this.templateUtenteForm = this.campiForm.group({
      templateProfilo: [this.request]
    });
  }

  update() {
    if (!this.utente) {
      this.getRequest(new TemplateUtenteAdapter(this.request).templateUtente);
    } else {
      this.getRequestAddUtente(new TemplateUtenteAdapter(this.request).templateUtente);
    }
  }

  raggruppaPermessi(permessi) {
    let writable = [];
    let readable = [];
    this.listaPermessi = permessi.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      })
    writable = permessi.filter(permesso =>  permesso.id.indexOf('_W_') !== -1);
    readable = permessi.filter(permesso =>  permesso.id.indexOf('_R_') !== -1);
    this.buildPermessi(writable, readable);
  }

  buildPermessi(writable, readable) {
    let permessiCustom: PermessoCustom[] = new Array<PermessoCustom>();
    for (let permessoR of readable) {
      let permessoCustom = new PermessoCustom();
      permessoCustom.readPermission = permessoR;
      for (let permessoW of writable) {
        if (permessoW.id.replace('_W_', '_R_') === permessoR.id) {
          permessoCustom.writePermission = permessoW;
        }
      }
      permessiCustom.push(permessoCustom);
    }
    this.permessiCustom = permessiCustom;
  }


  populateSelect() {
    if (!this.listaGruppiOperativi || (this.listaGruppiOperativi && this.listaGruppiOperativi.length === 0)) {
      this.helpers.getGruppiOperativi().subscribe(response => this.listaGruppiOperativi = response.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      }));
    }

    if (!this.listaGruppiOrganizzativi || (this.listaGruppiOrganizzativi && this.listaGruppiOrganizzativi.length === 0)) {
      this.operationService.getGruppiOrganizzativi().subscribe(response => this.listaGruppiOrganizzativi = response.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      }));
    }

    if (!this.listaGruppiVisibilita || (this.listaGruppiVisibilita && this.listaGruppiVisibilita.length === 0)) {
      this.operationService.getGruppiVisibilita().subscribe(response => this.listaGruppiVisibilita = response.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      }));
    }

    if (!this.listaRuoli || (this.listaRuoli && this.listaRuoli.length === 0)) {
      this.operationService.getGruppiByRuoli().subscribe(response => this.listaRuoli = response.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      }));
    }

    if (!this.listaPermessi || (this.listaPermessi && this.listaPermessi.length === 0)) {

      this.operationService.getGruppiByPermessi().subscribe(response => this.raggruppaPermessi(response));
    }

    if (this.utente && !this.addMod && (!this.listaTemplateUtente || (this.listaTemplateUtente && this.listaTemplateUtente.length === 0))) {
      this.operationService.getTemplatesUtente(this.urlGetTemplates).subscribe(response => this.datiTemplatesUtente(response));
    }

    if (!this.listaGruppiSpeciali || (this.listaGruppiSpeciali && this.listaGruppiSpeciali.length === 0)) {
      this.operationService.getGruppiDinamica(ServicePathsSettings.URL_GET_GRUPPI_SPECIALI).subscribe(response => this.listaGruppiSpeciali = response.sort((leftSide, rigthSide): number => {
        if (leftSide.nomeGruppo < rigthSide.nomeGruppo) return -1;
        if (leftSide.nomeGruppo > rigthSide.nomeGruppo) return 1;
        return 0;
      }));
    }
  }


  datiTemplatesUtente(response: TemplatesProfiloResponse) {
    if (response.returnCode === 'OK') {
      this.listaTemplateUtente = response.templateProfili;
    }
  }

  isCheckedGruppo(listInput: TemplateProfilo[], element): boolean {
    let result: boolean = false;
    if (this.getIndexById(listInput, element.id) !== -1) {
      result = true;
    }
    return result;
  }

  isCheckedGruppoRead(listInput: TemplateProfilo[], element: GruppoTerritoriale): boolean {
    let result: boolean = false;
    let readElement: GruppoTerritoriale = this.listaPermessi[this.getIndexGruppoTerritorialeById(this.listaPermessi, element.id.replace('_W_', '_R_'))];
    if (readElement && this.getIndexById(listInput, readElement.id) !== -1) {
      result = true;
    }
    return result;
  }

  onCheckGruppo(listInput: TemplateProfilo[], element: GruppoTerritoriale) {
    if (this.getIndexById(listInput, element.id) !== -1) {
      listInput.splice(this.getIndexById(listInput, element.id), 1);
    } else {
      listInput.push(Object.assign({}, new TemplateProfilo(element)));
    }
  }

  onCheckGruppoRuolo(listInput: TemplateProfilo[], element: GruppoTerritoriale) {
    if (this.getIndexById(listInput, element.id) !== -1) {
      listInput.splice(this.getIndexById(listInput, element.id), 1);
    } else {
      listInput.push(Object.assign({}, new TemplateRuolo(element)));
    }
  }

  onCheckGruppoOrganizzativo(listInput: any[], gruppo: any) {
    // imposta il gruppo principale
    listInput.splice(0, listInput.length, gruppo);

    // rimuovi il gruppo scelto dai permessi (se presente)
    const idx = this.request.permessiPerGruppoOrganizzativo
      ?.findIndex(p => p.idGruppo === gruppo.id);

    if (idx > -1) {
      this.request.permessiPerGruppoOrganizzativo.splice(idx, 1);
      delete this.permessiAperti[gruppo.id]; // chiudi il pannello se era aperto
    }
  }


  onCheckGruppoRead(permessoCustom: PermessoCustom) {
      if (this.getIndexById(this.request.templateProfiloPermessi, permessoCustom.readPermission.id) !== -1) {
        this.request.templateProfiloPermessi.splice(this.getIndexById(this.request.templateProfiloPermessi, permessoCustom.readPermission.id), 1);
      } else {
        this.request.templateProfiloPermessi.push(Object.assign({}, new TemplateProfilo(permessoCustom.readPermission)));
      }
  }

  onCheckGruppoWrite(permessoCustom: PermessoCustom) {
    if (this.getIndexById(this.request.templateProfiloPermessi, permessoCustom.writePermission.id) !== -1) {
      this.request.templateProfiloPermessi.splice(this.getIndexById(this.request.templateProfiloPermessi, permessoCustom.writePermission.id), 1);
    } else {
      this.request.templateProfiloPermessi.push(Object.assign({}, new TemplateProfilo(permessoCustom.writePermission)));
      if (this.getIndexById(this.request.templateProfiloPermessi, permessoCustom.readPermission.id) === -1) {
        this.request.templateProfiloPermessi.push(Object.assign({}, new TemplateProfilo(permessoCustom.readPermission)));
      }
    }
  }

  getIndexGruppoTerritorialeById(listInput: GruppoTerritoriale[], id: string): number {
    let index: number = -1;
    for (let i: number = 0; i < listInput.length; i++) {
      if (listInput[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  getIndexById(listInput: TemplateProfilo[], id: string): number {
    let index: number = -1;
    for (let i: number = 0; i < listInput.length; i++) {
      if (listInput[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  get hasGruppiOrganizzativiSelezionati(): boolean {
    const org = this.request?.permessiPerGruppoOrganizzativo;
    return Array.isArray(org) && org.length > 0;
  }

  get hasGruppiSpecialiSelezionati(): boolean {
    const spec = this.request?.templateProfiloGruppiSpeciali;
    return Array.isArray(spec) && spec.length > 0;
  }

  onSelectAllGruppiOperativi() {
    if (!this.allGruppiOperativi) {
      this.allGruppiOperativi = true;
      this.request.templateProfiloGruppiOperativi = [];
      for (let i: number = 0; i < this.listaGruppiOperativi.length; i++) {
        this.request.templateProfiloGruppiOperativi.push(Object.assign({}, new TemplateProfilo(this.listaGruppiOperativi[i])));
      }
    } else {
      this.allGruppiOperativi = false;
      this.request.templateProfiloGruppiOperativi = [];
    }
  }

  onSelectAllGruppiOrganizzativi() {
    if (!this.allGruppiOrganizzativi) {
      this.allGruppiOrganizzativi = true;
      this.request.templateProfiloGruppiOrganizzativi = [];
      for (let i: number = 0; i < this.listaGruppiOrganizzativi.length; i++) {
        this.request.templateProfiloGruppiOrganizzativi.push(Object.assign({}, new TemplateProfilo(this.listaGruppiOrganizzativi[i])));
      }
    } else {
      this.allGruppiOrganizzativi = false;
      this.request.templateProfiloGruppiOrganizzativi = [];
    }
  }

  onSelectAllGruppiVisibilita() {
    if (!this.allGruppiVisibilita) {
      this.allGruppiVisibilita = true;
      this.request.templateProfiloGruppiVisibilita = [];
      for (let i: number = 0; i < this.listaGruppiVisibilita.length; i++) {
        this.request.templateProfiloGruppiVisibilita.push(Object.assign({}, new TemplateProfilo(this.listaGruppiVisibilita[i])));
      }
    } else {
      this.allGruppiVisibilita = false;
      this.request.templateProfiloGruppiVisibilita = [];
    }
  }

  onSelectAllRuoli() {
    if (!this.allRuoli) {
      this.allRuoli = true;
      this.request.templateProfiloRuoli = [];
      for (let i: number = 0; i < this.listaRuoli.length; i++) {
        this.request.templateProfiloRuoli.push(Object.assign({}, new TemplateProfilo(this.listaRuoli[i])));
      }
    } else {
      this.allRuoli = false;
      this.request.templateProfiloRuoli = [];
    }
  }

  datiTemplateProfilo(response: TemplateProfiloResponse) {
    if (response.returnCode === 'OK') {
      this.request = response.templateProfilo;
    }
  }

  private onChangeTemplate(idTemplate: string) {
    this.operationService.getTemplateUtente(this.urlGetTemplate, idTemplate).subscribe(response => this.datiTemplateProfilo(response));
  }

  onToggleGruppoPermessi(gruppo: GruppoTerritoriale): void {
    if (!this.request.permessiPerGruppoOrganizzativo) {
      this.request.permessiPerGruppoOrganizzativo = [];
    }

    const index = this.request.permessiPerGruppoOrganizzativo.findIndex(
      p => p.idGruppo === gruppo.id
    );

    if (index >= 0) {
      this.request.permessiPerGruppoOrganizzativo.splice(index, 1);
      delete this.permessiAperti[gruppo.id];
    } else {
      const nuovoGruppo = new TemplatePermessoPerGruppoOrganizzativo(gruppo);
      this.request.permessiPerGruppoOrganizzativo.push(nuovoGruppo);
      this.permessiAperti[gruppo.id] = true;
    }
  }
  
  isGruppoPermessiSelezionato(gruppo: GruppoTerritoriale): boolean {
    return this?.request?.permessiPerGruppoOrganizzativo?.some(p => p.idGruppo === gruppo.id);
  }

  isCheckedPermesso(gruppo: GruppoTerritoriale, permesso: TemplateProfilo): boolean {
    const gruppoObj = this.request.permessiPerGruppoOrganizzativo.find(p => p.idGruppo === gruppo.id);
    return gruppoObj?.permessi?.some(p => p.id === permesso.id) ?? false;
  }

  sanitizeId(id: string): string {
    return id.replace(/[^a-zA-Z0-9-_]/g, '_'); // sostituisce caratteri speciali con "_"
  }


  isCheckedPermessoGruppo(gruppo: GruppoTerritoriale, permesso: GruppoTerritoriale): boolean {
    const gruppoPermessi = this.request.permessiPerGruppoOrganizzativo.find(p => p.idGruppo === gruppo.id);
    if (!gruppoPermessi || !gruppoPermessi.permessi) return false;
    return gruppoPermessi.permessi.some(p => p.id === permesso.id);
  }

  onCheckPermessoGruppo(gruppo: GruppoTerritoriale, permesso: any) {
    let gruppoPermessi = this.request.permessiPerGruppoOrganizzativo.find(p => p.idGruppo === gruppo.id);

    if (!gruppoPermessi) {
      gruppoPermessi = { idGruppo: gruppo.id, permessi: [] };
      this.request.permessiPerGruppoOrganizzativo.push(gruppoPermessi);
    }

    const idx = gruppoPermessi.permessi.findIndex(p => p.id === permesso.id);

    if (idx > -1) {
      // caso: già presente → rimuovo
      gruppoPermessi.permessi.splice(idx, 1);
    } else {
      // aggiungo il permesso selezionato
      gruppoPermessi.permessi.push(new TemplateProfilo(permesso));

      // se è un WRITE → aggiungo anche il READ corrispondente
      if (permesso.id.includes("_W_")) {
        const readId = permesso.id.replace("_W_", "_R_");
        const haGiaRead = gruppoPermessi.permessi.some(p => p.id === readId);

        if (!haGiaRead) {
          gruppoPermessi.permessi.push(new TemplateProfilo({ ...permesso, id: readId }));
        }
      }
    }
  }

  isSezionePermessiBloccata(): boolean {
    return !this.listaGruppiOrganizzativi?.some(g => 
      this.isCheckedGruppo(this.request.templateProfiloGruppiOrganizzativi, g)
    );
  }

  togglePermessi(gruppo: any) {
    this.permessiAperti[gruppo.id] = !this.permessiAperti[gruppo.id];
  }

  isPermessiAperto(gruppo: any): boolean {
    return !!this.permessiAperti[gruppo.id];
  }




  abstract getTemplateUtente(): TemplateUtenteProfilo;
  abstract getRequest(request: TemplateUtenteProfilo);
  abstract getRequestAddUtente(request: TemplateUtenteProfilo);


}
